import { useState } from "react";
import { useQuery } from "react-query";
import useDebounce from "./useDebounceSearch";
import { getOngoingConsent } from "services/contest.service";

export default function useOngoingContests(defaultQuery) {
  const [query, setQuery] = useState(
    defaultQuery || {
      page: 1,
      limit: 20,
      search: "",
    }
  );
  const debounceSearch = useDebounce(query.search, 1000);

  const { page } = query;
  const { isLoading, data, refetch } = useQuery(
    ["ongoing-contest", page, debounceSearch],
    async () => await getOngoingConsent(query)
  );

  const onQueryChange = (name, value) => {
    setQuery((q) => ({ ...q, [name]: value }));
  };

  const onFilter = (queryFilter) => {
    setQuery(queryFilter);
  };

  return { isLoading, data, onQueryChange, onFilter, refetch };
}
